var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "page-dialog center-dialog",
      attrs: {
        title: "特殊公告设置",
        visible: _vm.visible,
        width: "520px",
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": (val) => _vm.$emit("update:visible", val),
        closed: _vm.handleClosed,
      },
    },
    [
      _c(
        "div",
        { staticClass: "dialog-content" },
        [
          _c("div", { staticClass: "tip" }, [
            _vm._v("温馨提示：只有勾选的 VIP 等级会员可以看到特殊公告弹窗"),
          ]),
          _c(
            "el-form",
            {
              ref: "formRef",
              attrs: {
                model: _vm.form,
                "label-position": "top",
                size: "small",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "VIP 等级", prop: "vip_limit" } },
                [
                  _c(
                    "div",
                    { staticClass: "vip-checkboxes" },
                    [
                      _c(
                        "el-checkbox",
                        {
                          on: { change: _vm.handleCheckAllChange },
                          model: {
                            value: _vm.checkAll,
                            callback: function ($$v) {
                              _vm.checkAll = $$v
                            },
                            expression: "checkAll",
                          },
                        },
                        [_vm._v(" 全选 ")]
                      ),
                      _c(
                        "div",
                        { staticClass: "vip-items" },
                        [
                          _c(
                            "el-checkbox-group",
                            {
                              on: { change: _vm.handleCheckedVipChange },
                              model: {
                                value: _vm.form.vip_limit,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "vip_limit", $$v)
                                },
                                expression: "form.vip_limit",
                              },
                            },
                            _vm._l(_vm.vipOptions, function (item) {
                              return _c(
                                "el-checkbox",
                                {
                                  key: item.value,
                                  attrs: { label: item.value },
                                },
                                [_vm._v(" " + _vm._s(item.label) + " ")]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.handleCancel } }, [
            _vm._v("取消"),
          ]),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.loading },
              on: { click: _vm.handleConfirm },
            },
            [_vm._v("确认")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }